import { getAiAssistantUserMessageDisplayText } from './ai-assistant-ui-context';
import { AiHistoryMessage } from './ai-assistant.models';

const MAX_TITLE_LENGTH = 48;
const SHORT_ID_LENGTH = 8;
const STORAGE_PREFIX = 'aiAssistant.title.';

const getShortId = (conversationId: string): string => conversationId.slice(0, SHORT_ID_LENGTH);

const truncateTitle = (title: string): string => (title.length > MAX_TITLE_LENGTH ? `${title.slice(0, MAX_TITLE_LENGTH)}…` : title);

export const getFallbackTitle = (conversationId: string): string => `Conversation ${getShortId(conversationId)}`;

export const getConversationTitle = (conversationId: string, name?: string | null): string => {
  if (name) {
    return truncateTitle(getAiAssistantUserMessageDisplayText(name));
  }
  const stored = localStorage.getItem(`${STORAGE_PREFIX}${conversationId}`);
  return stored ?? getFallbackTitle(conversationId);
};

export const clearConversationTitles = (): void => {
  Object.keys(localStorage)
    .filter((key) => key.startsWith(STORAGE_PREFIX))
    .forEach((key) => localStorage.removeItem(key));
};

export const setTitleFromFirstUserMessage = (conversationId: string, messages: AiHistoryMessage[]): void => {
  const existing = localStorage.getItem(`${STORAGE_PREFIX}${conversationId}`);
  if (existing) {
    return;
  }
  const firstUserMessage = messages.find((m) => m.role === 'user');
  const firstUserText = firstUserMessage?.parts
    .filter((p) => p.type === 'OUTPUT')
    .map((p) => p.content)
    .join('');
  if (!firstUserText) {
    return;
  }
  const displayText = getAiAssistantUserMessageDisplayText(firstUserText);
  if (!displayText) {
    return;
  }
  localStorage.setItem(`${STORAGE_PREFIX}${conversationId}`, truncateTitle(displayText));
};

export const setTitleFromUserMessage = (conversationId: string, message: string): void => {
  const existing = localStorage.getItem(`${STORAGE_PREFIX}${conversationId}`);
  if (existing) {
    return;
  }
  const displayText = getAiAssistantUserMessageDisplayText(message);
  localStorage.setItem(`${STORAGE_PREFIX}${conversationId}`, truncateTitle(displayText));
};
